import React from 'react';
import '../styles/global.css';

export default function Loader() {
  return (
    <div className="loader-container">
      <div className="loader" aria-label="Loading"></div>
    </div>
  );
}
